<template>
  <BgImageLayout>
    <FormSubscriptionPeriod
      :showing="subscriptionModal"
      :original-tasks="taskApplicability"
      :disable-properties="['product_id']"
      :has-end-action="true"
      @close="subscriptionModal = false"
    />

    <FormCreateProduct
      :showing="productModal"
      context="index"
      @close-with-acquisition="startAcquisition"
      @create="reRenderTable++"
      @close="productModal = false"
    />

    <Grid gtr="auto 1fr" class="full-height shadow3 list-view-products relative-position">
      <CardHeader
        :ag-grid="agGrid"
        @create-new-product="productModal = true"
        @export="$refs.productsTable.exportToExcel()"
      />

      <ProductsTable
        :key="reRenderTable"
        ref="productsTable"
        @ag-grid="agGrid = $event"
        @show-subscription-modal="subscriptionModal = true"
      />
    </Grid>
  </BgImageLayout>
</template>

<script>
// Vuex
import VuexModule from './vuex-module'
// Libraries
import { mapGetters } from 'vuex'
// Components
import FormSubscriptionPeriod from '@components/forms/form-subscription-period/FormSubscriptionPeriod'
import FormCreateProduct from '@components/forms/form-create-product/FormCreateProduct'
import CardHeader from './components/CardHeader'
import ProductsTable from './components/products-table/ProductsTable'

export default {
  components: {
    FormSubscriptionPeriod,
    FormCreateProduct,
    CardHeader,
    ProductsTable
  },

  data: () => ({
    agGrid: null,
    productModal: false,
    subscriptionModal: false,
    reRenderTable: 1
  }),

  computed: {
    ...mapGetters('subscriptions/subscriptionPeriods', ['taskApplicability'])
  },

  beforeCreate() {
    this.$store.registerModule('lv-products', VuexModule)
  },

  destroyed() {
    this.$store.unregisterModule('lv-products')
  },

  methods: {
    async startAcquisition(productId) {
      this.productModal = false
      await this.$store.dispatch('subscriptions/subscriptionPeriods/setProductId', productId)

      this.subscriptionModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.list-view-products {
  border-radius: 2px;
  overflow: hidden;
  isolation: isolate;
}
</style>
